import { SVGProps } from 'react'

export const CircleChevronIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" width={26} height={26} fill="none" {...props}>
    <path
      fill="#fff"
      stroke="#DADBDD"
      d="M.5 13c0 6.903 5.598 12.5 12.5 12.5S25.5 19.903 25.5 13 19.903.5 13 .5.5 6.097.5 13Z"
    />
    <path
      fill="#404145"
      d="M12.962 17.146H13c.327.01.645-.114.876-.346l3.777-3.779a1.184 1.184 0 1 0-1.674-1.674L13 14.326l-2.979-2.98a1.184 1.184 0 1 0-1.674 1.675l3.777 3.778c.222.222.524.347.838.347Z"
    />
  </svg>
)
